import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';

import { PageHeader, Icon } from '@salesforce/design-system-react';

import './Header.scss';

export class Header extends Component {
  renderPageHeaderTitle() {
    const { variant } = this.props;
    return variant === 'settings' ? (
      <div>
        <h3 className="page-header-label">
          <FormattedMessage id="Header.settings.breadcrumb.setup" />
          {' > '}
          <Link to="/setup">
            <FormattedMessage id="Header.settings.breadcrumb.ect" />
          </Link>
        </h3>
        <h1 className="page-header-title">
          <FormattedMessage id="Header.settings.title" />
        </h1>
      </div>
    ) : (
      <div>
        <h3 className="page-header-label">
          <FormattedMessage id="Header.setup.label" />
        </h3>
        <h1 className="page-header-title">
          <FormattedMessage id="Header.setup.title" />
        </h1>
      </div>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;

    return (
      <PageHeader
        className="ect-page-header"
        icon={
          <Icon
            assistiveText={{
              label: formatMessage({ id: 'Header.setup.label' })
            }}
            category="utility"
            name="setup"
          />
        }
        title={this.renderPageHeaderTitle()}
        variant="base"
      />
    );
  }
}

Header.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.element,
  location: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(Header);
